import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { roles } from '../../../Shared/utils';
import { logout } from '../../../Functions/auth';
import { useAppContext } from '../../../Context/App/Provider';

import './Header.css';


export default function Header() {
  const { t } = useTranslation();
  const [{ version, sidebar, user }] = useAppContext();


  const handleLogout = () => logout().then(() => {
    // localStorage.removeItem('signedIn');  
    localStorage.clear();
    
    setTimeout(() => {      
      sessionStorage.clear();
    }, 500);  
    
    return window.location.pathname = '/'; // Reset context to the initial state
  });


  useEffect(() => {
    const dropdown = (e) => {
      if (typeof e.target.className === 'string' && !e.target.className.includes('dropdown')) {
        document.querySelector('#user') && document.querySelector('#user').classList.remove('open');
        document.querySelector('#admin') && document.querySelector('#admin').classList.remove('open');
      }
    };
    document.addEventListener('click', dropdown);

    return () => document.removeEventListener('click', dropdown);
  }, [t]);


  let circleColor = '';
  if (user.roleId === roles.stAdmin)
    circleColor = 'rgb(var(--accent-color))';
  else if (user.roleId === roles.dashboardSuperAdmin)
    circleColor = '#f1c40f';

  let userName = '';
  if (user.email.includes('DEMO_USER_$'))
    userName = "Demo user";
  else
    userName = user.email.includes('@') ? user.email.slice(0, user.email.indexOf('@')) : user.email;

  return (
    <div className="header">
      <div className={sidebar ? 'branding' : 'branding hidden'}>
        <img src="/assets/images/logo.png" alt="Logo" />
        <span>
          {t('global.dashboard')}
          {(version && version.version) && (
            <span style={{ display: "grid", fontSize: "12px" }}>
              {t('global.version_letter')}
              {version.version}
            </span>
          )}
        </span>
      </div>

      <div className="nav">
        <nav>
          <Link to="/reporting" className={window.location.pathname.startsWith('/reporting') ? 'selected' : null}>
            <span className="material-icons-round">bar_chart</span><span>{t('header.reporting')}</span>
          </Link>
          <Link to="/realtime" className={window.location.pathname.startsWith('/realtime') ? 'selected' : null}>
            <span className="material-icons-outlined">timer</span><span>{t('header.realtime')}</span>
            {/* <span className="material-icons-outlined">star_border</span><span>{t('header.realtime')}</span> */}
          </Link>

          {/* {user.roleId !== roles.user && ( */}
          <div className={window.location.pathname.startsWith('/admin') ? 'dropdown selected' : 'dropdown'}>
            <ul className="dropdown__list" id="admin" style={{ left: 0 }}>

              {user.roleId <= roles.admin && (
                <li><Link to="/admin/accounts">{t('header.admin.accounts')}</Link></li>
              )}

              {user.roleId <= roles.stAdmin && (
                <li><Link to="/admin/groups">{t('header.admin.group' + (user.roleId <= roles.stAdmin ? 's' : ''))}</Link></li>
              )}

              {user.roleId <= roles.stAdmin && (
                <li><Link to="/admin/locations">{t('header.admin.locations')}</Link></li>
              )}

              {/* {user.roleId !== roles.user && ( */}
                <li><Link to="/admin/scenarios">{t('header.admin.scenarios')}</Link></li>
              {/* )} */}

              {user.roleId !== roles.user && (
                <li><Link to="/admin/reports">{t('header.admin.reports')}</Link></li>
              )}

              {user.roleId <= roles.stAdmin && (
                <li><Link to="/admin/licenses">{t('header.admin.licenses')}</Link></li>
              )}

            </ul>

            <div className="dropdown__content" onClick={() => document.querySelector('#admin').classList.toggle('open')}>
              <span className="dropdown__open material-icons-outlined dropdown__icon">admin_panel_settings</span>
              <span className="dropdown__open dropdown__title">
                {
                  window.location.pathname.startsWith('/admin/scenarios/scenario') ? (t('header.admin.scenarios')) : (
                    window.location.pathname.startsWith('/admin') && !window.location.pathname.startsWith('/admin/scenarios/scenario') ? (
                      t('header.admin.' + (window.location.pathname.slice(window.location.pathname.lastIndexOf('/') + 1) || 'accounts'))
                    ) : (
                      t('header.admin.admin')
                    )
                  )
                }
              </span>
              <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
            </div>
          </div>
          {/* )} */}
        </nav>

        <div className={window.location.pathname.startsWith('/settings') ? 'dropdown selected' : 'dropdown'}>
          <ul className="dropdown__list" id="user">
            <li><Link to="/settings">{t('header.user.settings')}</Link></li>
            <li onClick={handleLogout}><span>{t('header.user.logout')}</span></li>
          </ul>

          <div className="dropdown__content" onClick={() => document.querySelector('#user').classList.toggle('open')}>
            <span className="dropdown__open material-icons-outlined dropdown__icon" style={{ color: circleColor }}>account_circle</span>
            <span className="dropdown__open dropdown__title">{userName}</span>
            <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
          </div>
        </div>
      </div>
    </div >
  );
}
